<app-menu>
  <div class="cc-shell min-h-full bg-[var(--cc-bg)] text-[var(--cc-text-main)]" [attr.data-theme]="themeMode">
    <div class="mx-auto flex min-h-[calc(100vh-64px)] max-w-[1760px] flex-col gap-3 px-3 py-3 sm:px-4 lg:px-5">
      <section class="cc-hero">
        <div class="flex min-w-0 flex-1 flex-col gap-3">
          <div class="cc-eyebrow">Contacts / Create</div>
          <div class="flex min-w-0 flex-wrap items-center gap-3">
            <h1 class="truncate text-3xl font-black">Create Contact</h1>
            <span class="cc-pill" [class.cc-pill--ready]="companyReady">
              <i class="fa-solid" [ngClass]="companyReady ? 'fa-circle-check' : 'fa-circle-info'"></i>
              {{ companyReady ? 'Company ready' : 'Company required' }}
            </span>
          </div>
          <div class="cc-meta-strip">
            <span><strong>{{ selectedContactTypeLabel }}</strong> type</span>
            <span><strong>{{ addressCount }}</strong> addresses</span>
            <span><strong>{{ peopleCount }}</strong> people</span>
            <span><strong>{{ postgridStatusLabel }}</strong> PostGrid</span>
            <span *ngIf="createdContactUuid"><strong>{{ createdContactUuid }}</strong> UUID</span>
          </div>
        </div>

        <div class="cc-toolbar-actions">
          <button type="button" class="cc-button cc-button--ghost" (click)="toggleTheme()">
            <i [class]="getThemeIcon()"></i>
            <span>{{ getThemeLabel() }}</span>
          </button>
          <button type="button" class="cc-button" (click)="setStep('review')">
            <i class="fa-solid fa-list-check"></i>
            <span>Review</span>
          </button>
          <button type="button" class="cc-button cc-button--primary" (click)="submitNewContact()" [disabled]="saving">
            <i class="fa-solid" [ngClass]="saving ? 'fa-rotate fa-spin' : 'fa-circle-plus'"></i>
            <span>{{ saving ? 'Creating' : 'Create Contact' }}</span>
          </button>
        </div>
      </section>

      <div *ngIf="errorMessage" class="cc-alert cc-alert--error">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ errorMessage }}</span>
        <button type="button" (click)="errorMessage = ''"><i class="fa-solid fa-xmark"></i></button>
      </div>

      <div *ngIf="successMessage" class="cc-alert cc-alert--success">
        <i class="fa-solid fa-circle-check"></i>
        <span>{{ successMessage }}</span>
        <button type="button" (click)="successMessage = ''"><i class="fa-solid fa-xmark"></i></button>
      </div>

      <main class="grid min-h-0 flex-1 gap-3 lg:grid-cols-[220px_minmax(0,1fr)]">
        <aside class="cc-side-panel">
          <button
            type="button"
            class="cc-step"
            *ngFor="let item of steps; let i = index"
            [class.is-active]="step === item.key"
            [class.has-error]="stepHasErrors(item.key)"
            (click)="setStep(item.key)"
          >
            <span class="cc-step-icon"><i class="fa-solid" [ngClass]="item.icon"></i></span>
            <span class="min-w-0 flex-1">
              <strong>{{ item.label }}</strong>
              <small>Step {{ i + 1 }} of {{ steps.length }}</small>
            </span>
            <i class="fa-solid" [ngClass]="stepHasErrors(item.key) ? 'fa-triangle-exclamation' : 'fa-chevron-right'"></i>
          </button>

          <section class="cc-postgrid-panel">
            <div class="flex items-center justify-between gap-3">
              <div>
                <div class="cc-eyebrow">Address Assist</div>
                <h2>PostGrid</h2>
              </div>
              <span class="cc-mini-pill">{{ postgridStatusLabel }}</span>
            </div>
            <div class="cc-postgrid-meter">
              <span [style.width.%]="addressCount ? 100 : 18"></span>
            </div>
            <div class="cc-postgrid-facts">
              <span><strong>{{ addressCount }}</strong> active</span>
              <span><strong>{{ addresses.length }}</strong> cards</span>
            </div>
          </section>
        </aside>

        <section class="cc-work-panel" [ngSwitch]="step">
          <section *ngSwitchCase="'company'" class="cc-section">
            <header class="cc-section-head">
              <div>
                <div class="cc-eyebrow">Profile</div>
                <h2>Company Details</h2>
              </div>
              <span class="cc-mini-pill" [class.cc-mini-pill--ready]="companyReady">{{ companyReady ? 'Ready' : 'Required' }}</span>
            </header>

            <form [formGroup]="contactForm" class="cc-form-grid cc-form-grid--dense">
                            <div class="cc-field lg:col-span-2">
                <label class="cc-field-label">Contact Types</label>
                <mat-form-field appearance="outline">
                                <mat-select formControlName="contact_type" required multiple>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="contactTypeFilterControl" placeholderLabel="Search contact types" noEntriesFoundLabel="No types found"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let type of filteredContactTypes" [value]="type">{{ type }}</mat-option>
                </mat-select>
                <mat-error *ngIf="controlInvalid(contactForm, 'contact_type')">Choose at least one contact type.</mat-error>
              </mat-form-field>
              </div>

                            <div class="cc-field lg:col-span-2">
                <label class="cc-field-label">Organization</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_organization" required>
                <mat-error *ngIf="controlInvalid(contactForm, 'contact_organization')">Organization is required.</mat-error>
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Active</label>
                <mat-form-field appearance="outline">
                                <mat-select formControlName="active" required>
                  <mat-option *ngFor="let type of typeListTrueFalse" [value]="type">{{ type }}</mat-option>
                </mat-select>
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Primary Email</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_email" type="email">
                <mat-error *ngIf="controlInvalid(contactForm, 'contact_email')">Enter a valid email.</mat-error>
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Category</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_category">
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">DOT Number</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="us_dot_no">
              </mat-form-field>
              </div>

              <div class="cc-subhead lg:col-span-5">
                <span>Primary Person</span>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Prefix</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_name_prefix">
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">First Name</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_name_given">
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Last Name</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_name_family">
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Title</label>
                <mat-form-field appearance="outline">
                                <mat-select formControlName="contact_title">
                  <mat-option value="">None</mat-option>
                  <mat-option *ngFor="let type of typeListContactTitle" [value]="type">{{ type }}</mat-option>
                </mat-select>
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Role</label>
                <mat-form-field appearance="outline">
                                <mat-select formControlName="contact_role">
                  <mat-option value="">None</mat-option>
                  <mat-option *ngFor="let type of typeListContactRole" [value]="type">{{ type }}</mat-option>
                </mat-select>
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Nickname</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_nickname">
              </mat-form-field>
              </div>

                            <div class="cc-field">
                <label class="cc-field-label">Time Zone</label>
                <mat-form-field appearance="outline">
                                <mat-select formControlName="contact_time_zone">
                  <mat-option value="">None</mat-option>
                  <mat-option *ngFor="let type of typeListTimeZone" [value]="type">{{ type }}</mat-option>
                </mat-select>
              </mat-form-field>
              </div>

                            <div class="cc-field lg:col-span-2">
                <label class="cc-field-label">URL</label>
                <mat-form-field appearance="outline">
                                <input matInput formControlName="contact_url">
              </mat-form-field>
              </div>

                            <div class="cc-field lg:col-span-2">
                <label class="cc-field-label">Note</label>
                <mat-form-field appearance="outline">
                                <textarea matInput formControlName="contact_note" rows="2"></textarea>
              </mat-form-field>
              </div>
            </form>
          </section>

          <section *ngSwitchCase="'addresses'" class="cc-section">
            <header class="cc-section-head">
              <div>
                <div class="cc-eyebrow">PostGrid Assist</div>
                <h2>Addresses</h2>
              </div>
              <button type="button" class="cc-button cc-button--accent" (click)="addAddress()">
                <i class="fa-solid fa-plus"></i>
                <span>Add Address</span>
              </button>
            </header>

            <article class="cc-repeat-card" *ngFor="let address of addresses; let i = index" [formGroup]="address.form">
              <header class="cc-card-head">
                <div class="min-w-0">
                  <div class="cc-eyebrow">Address {{ i + 1 }}</div>
                  <h3>{{ address.form.get('address_type')?.value || 'Address' }}</h3>
                </div>
                <div class="cc-card-actions">
                  <span class="cc-address-status" [ngClass]="addressStatusClass(address)">
                    <i [class]="addressStatusIcon(address)"></i>
                    {{ addressStatusLabel(address) }}
                  </span>
                  <button type="button" class="cc-icon-button" (click)="removeAddress(i)" title="Remove address">
                    <i class="fa-solid" [ngClass]="addresses.length === 1 ? 'fa-eraser' : 'fa-trash'"></i>
                  </button>
                </div>
              </header>

              <div class="cc-form-grid">
                                <div class="cc-field">
                  <label class="cc-field-label">Address Type</label>
                  <mat-form-field appearance="outline">
                                    <mat-select formControlName="address_type" (selectionChange)="onAddressBlur(i)">
                    <mat-option *ngFor="let type of typeList" [value]="type">{{ type }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="controlInvalid(address.form, 'address_type')">Type is required.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field lg:col-span-2">
                  <label class="cc-field-label">Street</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="address_street" [matAutocomplete]="addressAuto" (input)="onAddressInput(i)" (blur)="onAddressBlur(i)">
                  <mat-autocomplete #addressAuto="matAutocomplete" (optionSelected)="selectAddressSuggestion($event, i)">
                    <mat-option *ngFor="let suggestion of address.suggestions" [value]="suggestion.label">
                      {{ suggestion.label }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="controlInvalid(address.form, 'address_street')">Street is required.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Suite / Unit</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="address_extended" (input)="onAddressBlur(i)">
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Community</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="address_community" (input)="onAddressBlur(i)">
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Country</label>
                  <mat-form-field appearance="outline">
                                    <mat-select formControlName="address_country" (selectionChange)="onCountryChange(i)">
                    <mat-option value="">None</mat-option>
                    <mat-option *ngFor="let type of typeListCountry" [value]="type">{{ type }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="controlInvalid(address.form, 'address_country')">Country is required.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">State / Province</label>
                  <mat-form-field appearance="outline">
                                    <mat-select formControlName="address_region" (selectionChange)="onAddressBlur(i)">
                    <mat-option value="">None</mat-option>
                    <mat-option *ngFor="let type of getAddressStates(address.form.get('address_country')?.value)" [value]="type">{{ type }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="controlInvalid(address.form, 'address_region')">State or province is required.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">City</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="address_locality" (input)="onAddressBlur(i)">
                  <mat-error *ngIf="controlInvalid(address.form, 'address_locality')">City is required.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Postal / ZIP</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="address_postal_code" (input)="onAddressBlur(i)">
                  <mat-error *ngIf="controlInvalid(address.form, 'address_postal_code')">Postal or ZIP is required.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field lg:col-span-2">
                  <label class="cc-field-label">Description</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="address_description" (input)="onAddressBlur(i)">
                </mat-form-field>
                </div>
              </div>
            </article>
          </section>

          <section *ngSwitchCase="'people'" class="cc-section">
            <header class="cc-section-head">
              <div>
                <div class="cc-eyebrow">Phones Table</div>
                <h2>People & Subcontacts</h2>
              </div>
              <button type="button" class="cc-button cc-button--accent" (click)="addPerson()">
                <i class="fa-solid fa-user-plus"></i>
                <span>Add Person</span>
              </button>
            </header>

            <article class="cc-repeat-card" *ngFor="let person of people; let i = index" [formGroup]="person">
              <header class="cc-card-head">
                <div class="min-w-0">
                  <div class="cc-eyebrow">Subcontact {{ i + 1 }}</div>
                  <h3>{{ person.get('contact_name')?.value || person.get('contact_email')?.value || 'Person' }}</h3>
                </div>
                <button type="button" class="cc-icon-button" (click)="removePerson(i)" title="Remove person">
                  <i class="fa-solid" [ngClass]="people.length === 1 ? 'fa-eraser' : 'fa-trash'"></i>
                </button>
              </header>

              <div class="cc-form-grid">
                                <div class="cc-field">
                  <label class="cc-field-label">Name</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="contact_name" (input)="onPersonInput(i)">
                  <mat-error *ngIf="controlInvalid(person, 'contact_name')">Name is required when this row has details.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Email</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="contact_email" type="email" (input)="onPersonInput(i)">
                  <mat-error *ngIf="controlInvalid(person, 'contact_email')">Enter a valid email.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Role</label>
                  <mat-form-field appearance="outline">
                                    <mat-select formControlName="contact_role" (selectionChange)="onPersonInput(i)">
                    <mat-option value="">None</mat-option>
                    <mat-option *ngFor="let type of typeListContactRole" [value]="type">{{ type }}</mat-option>
                  </mat-select>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Phone Number</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="phone_number" (input)="onPersonInput(i)">
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Phone Type</label>
                  <mat-form-field appearance="outline">
                                    <mat-select formControlName="phone_type" (selectionChange)="onPersonInput(i)">
                    <mat-option *ngFor="let type of typeListPhone" [value]="type">{{ type }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="controlInvalid(person, 'phone_type')">Phone type is required with a phone number.</mat-error>
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Extension</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="phone_extension" (input)="onPersonInput(i)">
                </mat-form-field>
                </div>

                                <div class="cc-field lg:col-span-2">
                  <label class="cc-field-label">Description</label>
                  <mat-form-field appearance="outline">
                                    <input matInput formControlName="phone_description" (input)="onPersonInput(i)">
                </mat-form-field>
                </div>

                                <div class="cc-field">
                  <label class="cc-field-label">Primary</label>
                  <mat-form-field appearance="outline">
                                    <mat-select formControlName="phone_primary">
                    <mat-option [value]="false">False</mat-option>
                    <mat-option [value]="true">True</mat-option>
                  </mat-select>
                </mat-form-field>
                </div>
              </div>
            </article>
          </section>

          <section *ngSwitchCase="'review'" class="cc-section">
            <header class="cc-section-head">
              <div>
                <div class="cc-eyebrow">Final Check</div>
                <h2>Review</h2>
              </div>
              <button type="button" class="cc-button cc-button--primary" (click)="submitNewContact()" [disabled]="saving">
                <i class="fa-solid" [ngClass]="saving ? 'fa-rotate fa-spin' : 'fa-circle-plus'"></i>
                <span>{{ saving ? 'Creating' : 'Create Contact' }}</span>
              </button>
            </header>

            <div class="cc-review-grid">
              <article class="cc-review-card">
                <div class="cc-eyebrow">Company</div>
                <h3>{{ organizationLabel }}</h3>
                <dl>
                  <div><dt>Type</dt><dd>{{ selectedContactTypeLabel }}</dd></div>
                  <div><dt>Email</dt><dd>{{ contactForm.get('contact_email')?.value || '-' }}</dd></div>
                  <div><dt>Active</dt><dd>{{ contactForm.get('active')?.value }}</dd></div>
                  <div><dt>Role</dt><dd>{{ contactForm.get('contact_role')?.value || '-' }}</dd></div>
                </dl>
              </article>

              <article class="cc-review-card">
                <div class="cc-eyebrow">Addresses</div>
                <h3>{{ addressCount }} active</h3>
                <div class="cc-review-list" *ngIf="activeAddressValues.length; else noAddresses">
                  <div *ngFor="let address of activeAddressValues">
                    <strong>{{ address.address_type }}</strong>
                    <span>{{ address.address_street }}</span>
                    <small>{{ address.address_locality }}, {{ address.address_region }} {{ address.address_postal_code }}</small>
                  </div>
                </div>
                <ng-template #noAddresses><p class="cc-empty-line">No addresses.</p></ng-template>
              </article>

              <article class="cc-review-card">
                <div class="cc-eyebrow">People</div>
                <h3>{{ peopleCount }} active</h3>
                <div class="cc-review-list" *ngIf="activePeopleValues.length; else noPeople">
                  <div *ngFor="let person of activePeopleValues">
                    <strong>{{ person.contact_name }}</strong>
                    <span>{{ person.contact_email || '-' }}</span>
                    <small>{{ person.phone_number || '-' }} {{ person.phone_extension ? 'x' + person.phone_extension : '' }}</small>
                  </div>
                </div>
                <ng-template #noPeople><p class="cc-empty-line">No subcontacts.</p></ng-template>
              </article>
            </div>
          </section>
        </section>
      </main>
    </div>
  </div>
</app-menu>
